(() => {
  // Product-specific presentation only: shared File metadata stays unchanged.
  const scopedGalleryAlts = {
    "9689316983043": {
      "36519187579139": "BlackVue front dash cam with phone app illustration",
      "36519187611907": "BlackVue front camera with Full HD, STARVIS, Wi-Fi and parking-mode icons"
    },
    "9184002605315": {
      "36519040876803": "BlackboxMyCar PowerCell 8 battery pack connection panel"
    },
    "9299009175811": {
      "36519040876803": "BlackboxMyCar PowerCell 8 battery pack connection panel"
    },
    "8729076531459": {
      "36519049330947": "BlackVue front and rear cameras with a refurbished badge",
      "36519049363715": "BlackVue front-camera ports and rear camera views",
      "36519049396483": "BlackVue Full HD front and rear cameras and control diagrams"
    },
    "9045549383939": {
      "36519092945155": "BlackVue 4K front dash cam with phone app and refurbished badge",
      "36519092977923": "BlackVue 4K front camera with Cloud, Wi-Fi and parking-mode icons",
      "36519093010691": "BlackVue front camera ports, GNSS and wireless status indicators",
      "36519093043459": "BlackVue front camera speaker and recording-status LED diagram",
      "36519093076227": "BlackVue camera touch sensor for manual event recording"
    },
    "10323503022330": {
      "30371516285178": "Nexar Pro road and infrared cabin cameras with suction mount",
      "30371516416250": "Nexar Pro front and cabin recording illustration",
      "30371516743930": "Nexar Pro cameras, mount positions and feature icons",
      "30371516875002": "Nexar Pro parking-incident app illustration with front and cabin cameras"
    },
    "10323503055098": {
      "33323630493946": "Philips GoSure GS5101D 1600p front and rear cameras with app illustration",
      "33323630592250": "Philips GoSure GS5101D dash cam installed on a windshield"
    },
    "8739579887866": {
      "34370797633786": "Refurbished BlackVue front dash cam",
      "34370797666554": "BlackVue Full HD front camera with Cloud and parking-mode feature icons"
    },
    "8978401427715": {
      "36519195115779": "BlackVue Cloud and computer or smartphone playback illustration"
    }
  };
  const applyScopedGalleryAlts = (root) => {
    let galleryVariants;
    try {
      galleryVariants = JSON.parse(root.querySelector('[data-bbmc-gallery-variants]')?.textContent || '[]');
    } catch { return; }
    if (!Array.isArray(galleryVariants) || !galleryVariants.length) return;
    const variantIds = galleryVariants.map((variant) => String(variant?.id)).sort();
    if (new Set(variantIds).size !== variantIds.length || variantIds.some((id) => !/^\d+$/.test(id))) return;
    const matchingProducts = [];
    document.querySelectorAll('script[type="application/json"][data-section-type="static-product"][data-section-data]').forEach((script) => {
      try {
        const product = JSON.parse(script.textContent).product;
        if (!product || !Array.isArray(product.variants)) return;
        const ids = product.variants.map((variant) => String(variant?.id)).sort();
        if (ids.length === variantIds.length && ids.every((id, i) => id === variantIds[i])) matchingProducts.push(String(product.id));
      } catch { /* A non-matching or malformed section cannot grant an override. */ }
    });
    const productIds = [...new Set(matchingProducts)];
    if (productIds.length !== 1 || !Object.prototype.hasOwnProperty.call(scopedGalleryAlts, productIds[0])) return;
    const alts = scopedGalleryAlts[productIds[0]];
    const slides = [...root.querySelectorAll('[data-bbmc-gallery-slide]')];
    const thumbs = [...root.querySelectorAll('[data-bbmc-gallery-thumbnail]')];
    slides.forEach((slide) => {
      if (slide.dataset.mediaType !== 'image') return;
      const mediaId = String(slide.dataset.mediaId);
      if (!Object.prototype.hasOwnProperty.call(alts, mediaId)) return;
      const image = slide.querySelector('img');
      if (!image) return;
      const alt = alts[mediaId];
      image.alt = alt;
      slide.querySelector('[data-bbmc-gallery-zoom]')?.setAttribute('aria-label', 'Zoom ' + alt);
      thumbs.filter((thumb) => String(thumb.dataset.mediaId) === mediaId).forEach((thumb) => {
        const thumbnailImage = thumb.querySelector('img');
        if (thumbnailImage) thumbnailImage.alt = alt;
        thumb.setAttribute('aria-label', 'Show ' + alt);
      });
    });
  };
  document.querySelectorAll('[data-bbmc-product-media-gallery]').forEach(applyScopedGalleryAlts);
})();
